export default "__VITE_ASSET__BCUXq$g9__"